import { StudentDetailsState } from '../initial.state';
import { StudentmanagementActions } from '../actions/studentManagement.actions';

function StudentManagementReducer(state = new StudentDetailsState(), action) {
  switch (action.type) {
    case StudentmanagementActions.STUDENT_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        studentDetails: action.payload.data,
      };
    case StudentmanagementActions.STUDENT_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        subscriptionsList: action.payload.data,
      };
    case StudentmanagementActions.STUDENT_INVOICES_SUCCESS:
      return {
        ...state,
        invoicesList: action.payload.data,
      };
    case StudentmanagementActions.STUDENT_EMAIL_VERIFY_SUCCESS:
      return {
        ...state,
        emailVerified: true,
      };
    default:
      return {
        ...state,
      };
  }
}

export { StudentManagementReducer };
